import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { AuthProvider } from './lib/useAuth'
import { I18nProvider } from './i18n'
import { Footer, Nav } from './components/Chrome'
import ConsentBanner from './components/ConsentBanner'
import { startIfConsented } from './lib/analytics'
import Landing from './pages/Landing'
import Account from './pages/Account'
import License from './pages/License'
import { Privacy, Terms } from './pages/Legal'

// Réactive la mesure si l'utilisateur avait déjà accepté lors d'une visite précédente.
startIfConsented()

export default function App() {
  return (
    <BrowserRouter>
      <I18nProvider>
      <AuthProvider>
        <div className="aurora" />
        <div className="page">
          <Nav />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/account" element={<Account />} />
            <Route path="/license" element={<License />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="*" element={<Landing />} />
          </Routes>
          <Footer />
        </div>
        <ConsentBanner />
      </AuthProvider>
      </I18nProvider>
    </BrowserRouter>
  )
}
